import { ENTITY_TYPE } from 'common/constants';
import { MenuItemDef } from './dashboard/nav';
import {
  AssessmentOutlined,
  BadgeOutlined,
  BeachAccess,
  Brush,
  CasesOutlined,
  CompareArrows,
  Dashboard,
  FormatColorFill,
  FreeCancellation,
  GroupOutlined,
  Groups2Outlined,
  Home,
  ListAlt,
  Payments,
  RecentActorsOutlined,
  RequestPage,
  RequestPageOutlined,
  RequestQuoteOutlined,
  Schedule,
  Title,
  Today,
  ViewTimelineOutlined,
  WorkOffOutlined,
  AssignmentAdd,
  ReceiptLong,
  AccountBalanceWallet,
  LinkOff,
} from '@mui/icons-material';

export const navData: MenuItemDef[] = [
  {
    labelKey: 'mainNavigation.home',
    path: '/',
    icon: <Home />,
  },
  {
    labelKey: 'mainNavigation.clients',
    path: '/clients',
    icon: <GroupOutlined />,
    identifier: 'ui.nav.clients',
  },
  {
    labelKey: 'mainNavigation.providers',
    path: '/providers',
    icon: <RecentActorsOutlined />,
    identifier: 'ui.nav.providers',
  },
  {
    labelKey: 'mainNavigation.projects',
    path: '/projects',
    icon: <CasesOutlined />,
    identifier: 'ui.nav.projects',
  },
  {
    labelKey: 'mainNavigation.timesheet',
    path: '/timesheet',
    icon: <ViewTimelineOutlined />,
    identifier: 'ui.nav.timesheet',
  },
  {
    labelKey: 'mainNavigation.employees',
    path: '/employees',
    icon: <BadgeOutlined />,
    identifier: 'ui.nav.employees',
  },
  {
    labelKey: 'mainNavigation.myTeam',
    path: '/myteam',
    icon: <Groups2Outlined />,
    requiresSupervisor: true,
  },
  // Reports Menu with children
  {
    labelKey: 'mainNavigation.reports',
    path: '/reports',
    icon: <AssessmentOutlined />,
    entityType: ENTITY_TYPE.ANY,
    identifier: 'ui.nav.reports',
    children: [
      {
        labelKey: 'mainNavigation.timesheet',
        path: '/reports/timesheet',
        icon: <Schedule />,
        entityType: ENTITY_TYPE.EMPLOYEE,
        identifier: 'ui.nav.reports.my-timesheet',
      },
      {
        labelKey: 'mainNavigation.timesheet',
        path: '/reports/timesheet/client',
        icon: <Schedule />,
        entityType: ENTITY_TYPE.CLIENT,
        identifier: 'ui.nav.reports.my-timesheet',
      },
      {
        labelKey: 'mainNavigation.billing',
        path: '/reports/billing',
        icon: <Payments />,
        entityType: ENTITY_TYPE.EMPLOYEE,
        identifier: 'ui.nav.reports.billing',
      },
      {
        labelKey: 'mainNavigation.billing',
        path: '/reports/billing/client',
        icon: <RequestPage />,
        entityType: ENTITY_TYPE.CLIENT,
        identifier: 'ui.nav.reports.billing',
      },
      {
        labelKey: 'mainNavigation.utilization',
        path: '/reports/utilization',
        icon: <AssignmentAdd />,
        entityType: ENTITY_TYPE.ANY,
        identifier: 'ui.nav.reports.utilization',
      },
      {
        labelKey: 'mainNavigation.allocationVsTimesheet',
        path: '/reports/allocation-vs-timesheet',
        icon: <CompareArrows />,
        entityType: ENTITY_TYPE.ANY,
        identifier: 'ui.nav.reports.allocation-vs-timesheet',
      },
    ],
  },
  // Human Resources Menu with children
  {
    labelKey: 'mainNavigation.humanResources',
    path: '/humanresources',
    icon: <Groups2Outlined />,
    viewScopes: ['pto.read', 'nonworkingday.read'],
    editScopes: ['pto.read', 'nonworkingday.read'],
    entityType: ENTITY_TYPE.ANY,
    children: [
      {
        labelKey: 'mainNavigation.regime',
        path: '/regime',
        icon: <Today />,
        viewScopes: ['pto.read', 'pto.add', 'pto.edit'],
        editScopes: ['pto.read', 'pto.add', 'pto.edit'],
        entityType: ENTITY_TYPE.EMPLOYEE,
      },
      {
        labelKey: 'mainNavigation.myPTO',
        path: '/timeOff',
        icon: <WorkOffOutlined />,
        viewScopes: ['pto.read', 'pto.add', 'pto.edit'],
        editScopes: ['pto.read', 'pto.add', 'pto.edit'],
        entityType: ENTITY_TYPE.EMPLOYEE,
      },
      {
        labelKey: 'mainNavigation.manage.PTO',
        path: '/timeOffHR',
        icon: <FreeCancellation />,
        viewScopes: ['timeoff.rrhh'],
        editScopes: ['timeoff.rrhh'],
        entityType: ENTITY_TYPE.EMPLOYEE,
      },
      {
        labelKey: 'mainNavigation.holidays',
        path: '/Calendar/Holidays',
        icon: <BeachAccess />,
        viewScopes: ['nonworkingday.read', 'nonworkingday.add', 'nonworkingday.edit'],
        editScopes: ['nonworkingday.add', 'nonworkingday.edit'],
        entityType: ENTITY_TYPE.EMPLOYEE,
      },
    ],
  },
  // Invoices Menu with children
  {
    labelKey: 'mainNavigation.invoiceOrBilling',
    path: '/invoices-menu',
    icon: <RequestPageOutlined />,
    viewScopes: ['invoice.read', 'invoices.supplier.read', 'accountspayable.read', 'accountspayable.client.read'],
    editScopes: ['invoice.read', 'invoices.supplier.read', 'accountspayable.read', 'accountspayable.client.read'],
    entityType: ENTITY_TYPE.ANY,
    children: [
      {
        labelKey: 'mainNavigation.invoice.myInvoices',
        path: '/myInvoices',
        icon: <RequestQuoteOutlined />,
        viewScopes: ['invoice.read'],
        editScopes: ['invoice.read'],
        entityType: ENTITY_TYPE.EMPLOYEE,
      },
      {
        labelKey: 'mainNavigation.invoice.myInvoices',
        path: '/myInvoices',
        icon: <RequestQuoteOutlined />,
        viewScopes: ['invoice.read'],
        editScopes: ['invoice.read'],
        entityType: ENTITY_TYPE.PROVIDER,
      },
      {
        labelKey: 'mainNavigation.billing.accountsPayable',
        path: '/accountspayable',
        icon: <Payments />,
        viewScopes: ['accountspayable.read', 'accountspayable.edit'],
        editScopes: ['accountspayable.read', 'accountspayable.edit'],
        entityType: ENTITY_TYPE.CORPORATE_ENTITY,
      },
      {
        labelKey: 'mainNavigation.billing.invoicing',
        path: '/invoicing',
        icon: <RequestPage />,
        viewScopes: ['accountspayable.read', 'accountspayable.edit'],
        editScopes: ['accountspayable.read', 'accountspayable.edit'],
        entityType: ENTITY_TYPE.CORPORATE_ENTITY,
      },
      {
        labelKey: 'mainNavigation.billing.invoicing',
        path: '/invoicing',
        icon: <RequestPage />,
        viewScopes: ['accountspayable.client.read'],
        editScopes: ['accountspayable.client.read'],
        entityType: ENTITY_TYPE.CLIENT,
      },
      {
        labelKey: 'mainNavigation.billing.newInvoice',
        path: '/newinvoice',
        icon: <AssignmentAdd />,
        viewScopes: ['invoices.supplier.read', 'invoices.supplier.add'],
        editScopes: ['invoices.supplier.read', 'invoices.supplier.add'],
        entityType: ENTITY_TYPE.EMPLOYEE,
      },
      {
        labelKey: 'mainNavigation.billing.upload',
        path: '/uploadinvoice',
        icon: <RequestQuoteOutlined />,
        viewScopes: ['invoices.supplier.read', 'invoices.supplier.add'],
        editScopes: ['invoices.supplier.read', 'invoices.supplier.add'],
        entityType: ENTITY_TYPE.EMPLOYEE,
      },
    ],
  },

  // Finance Menu
  {
    labelKey: 'mainNavigation.finance',
    path: '/finance',
    icon: <AccountBalanceWallet />,
    viewScopes: ['account.read'],
    editScopes: ['account.edit'],
    entityType: ENTITY_TYPE.CORPORATE_ENTITY,
    children: [
      {
        labelKey: 'mainNavigation.finance.accounts',
        path: '/accounts',
        icon: <ReceiptLong />,
        viewScopes: ['account.read'],
        editScopes: ['account.edit'],
        entityType: ENTITY_TYPE.CORPORATE_ENTITY,
      },{
        labelKey: 'mainNavigation.finance.unreconciledAp',
        path: '/reports/unreconciled-ap',
        icon: <LinkOff />,
        viewScopes: ['account.read'],
        editScopes: ['account.edit'],
        entityType: ENTITY_TYPE.CORPORATE_ENTITY,
      },{
        labelKey: 'mainNavigation.finance.unreconciledAr',
        path: '/reports/unreconciled-invoices',
        icon: <LinkOff />,
        viewScopes: ['account.read'],
        editScopes: ['account.edit'],
        entityType: ENTITY_TYPE.CORPORATE_ENTITY,
      },
    ],
  },

  // Showcase Menu with children
  /*{
    labelKey: 'Showcase',
    icon: <Brush />,
    children: [
      {
        labelKey: 'Components',
        path: '/showcase/components',
        icon: <Dashboard />,
      },
      {
        labelKey: 'Colors',
        path: '/showcase/colors',
        icon: <FormatColorFill />,
      },
      {
        labelKey: 'Typography',
        path: '/showcase/typography',
        icon: <Title />,
      },
      {
        labelKey: 'DataGrid',
        path: '/showcase/datagrid',
        icon: <ListAlt />,
      },
    ],
  },*/
];
